<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>Django Generations</h1>
<h1 class="bk1">Hearing Ethnorace, Citizenship, and Jazz Manouche in France</h1>
<p class="bkau">Siv B. Lie</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lie-0004.vue?5af6354d